import Menu from "../components/Menu";
import ImageZoom from "../components/ImageZoom";
import { motion, AnimatePresence } from "framer-motion";
import qr from "../images/qr.png";
import { Row, Col } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import "yet-another-react-lightbox/styles.css";
import "yet-another-react-lightbox/plugins/captions.css";
import CreditCardIcon from "@mui/icons-material/CreditCard";
import { Helmet } from "react-helmet";

export default function Contact() {
  const textVariants = {
    hidden: { opacity: 0, y: 40 },
    visible: {
      opacity: 1,
      y: 0,
      transition: { duration: 1.0, ease: "easeOut" },
    },
  };

  return (
    <>
      <Helmet>
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@id": "https://tomaszfotograf.pl/kontakt-tomasz-fotograf#contact",
            "@type": "ContactPage",
            name: "Kontakt - Tomasz Fotograf",
            description:
              "Skontaktuj się ze mną, aby umówić sesję fotograficzną wnętrz, nieruchomości lub zapytać o ofertę wideo w Warszawie i okolicach.",
            url: "https://tomaszfotograf.pl/kontakt-tomasz-fotograf",
            mainEntity: {
              "@type": "ProfessionalService",
              name: "Tomasz Fotograf",
              image:
                "http://localhost:3000/static/media/DSC_8884.3288ea407609b8ed0c77.jpg",
              telePresence: "https://tomaszfotograf.pl/kontakt-tomasz-fotograf",
              areaServed: {
                "@type": "AdministrativeArea",
                name: "Warszawa i okolice",
              },
              contactPoint: {
                "@type": "ContactPoint",
                telephone: "+48570860088",
                contactType: "customer service",
                email: "kontakt@tomaszfotograf.pl",
                availableLanguage: ["Polish", "English"],
              },
              address: {
                "@type": "PostalAddress",
                addressLocality: "Warszawa",
                addressCountry: "PL",
              },
              openingHoursSpecification: [
                {
                  "@type": "OpeningHoursSpecification",
                  dayOfWeek: [
                    "Monday",
                    "Tuesday",
                    "Wednesday",
                    "Thursday",
                    "Friday",
                    "Saturday",
                  ],
                  opens: "09:00",
                  closes: "19:00",
                },
              ],
            },
          })}
        </script>
      </Helmet>
      <Menu />

      <section
        className="section section-gray section-contact"
        key="sectiongray"
      >
        <AnimatePresence>
          <motion.div
            initial="hidden"
            animate="visible"
            exit="hidden"
            variants={textVariants}
          >
            <Row key="row3" style={{ alignItems: "center" }}>
              <p className="h4a" style={{ marginBottom: "1.5rem" }}>
                Napisz lub zadzwoń, aby ustalić zakres sesji, termin
                i&nbsp;indywidualną wycenę.
              </p>
            </Row>
            <Row key="row1" style={{ alignItems: "flex-start" }}>
              {" "}
              <Col
                xs={12}
                md={4}
                style={{ textAlign: "center", marginBottom: "2rem" }}
              >
                <ImageZoom src={qr} alt="tomek" />
                <p className="h4a">
                  <CreditCardIcon />
                  &nbsp; Zaimportuj wizytówkę{" "}
                </p>
              </Col>
              <Col xs={12} md={8}>
                <div className="contact-card">
                  <p className="contact-name">TOMASZ JASKULSKI</p>
                  <div className="contact-details">
                    <p>
                      <strong>tel:</strong>{" "}
                      <a href="tel:+48570860088">+48 570 86 00 88</a>
                    </p>
                    <p>
                      <strong>email:</strong>{" "}
                      <a href="mailto:kontakt@tomaszfotograf.pl">
                        kontakt@tomaszfotograf.pl
                      </a>
                    </p>
                    <p>
                      <a
                        href="https://tomaszfotograf.pl"
                        target="_blank"
                        rel="noreferrer"
                      >
                        tomaszfotograf.pl
                      </a>
                    </p>
                    <hr className="contact-divider" />
                    <p className="contact-address">
                      Piaseczno, ul. Cichej Łąki 5
                    </p>
                    <p className="contact-nip">NIP: 1231529362</p>
                  </div>
                </div>
              </Col>
            </Row>
            <Row
              key="row1"
              style={{ alignItems: "flex-start", marginTop: "2.5rem" }}
            >
              <p className="h5a" style={{ marginBottom: "1.5rem" }}>
                Fotografia nieruchomości, wnętrz, filmy, dron, staging |
                Warszawa i okolice
              </p>
            </Row>
          </motion.div>
        </AnimatePresence>
      </section>
    </>
  );
}
